/// <amd-module name="Tfs/ReduxCommon/Modules/Teams/TeamContracts" />
import { ITeam } from "Tfs/ReduxCommon/Contracts/Team";

export interface ITeamAwareState {
    teamState: ITeamState;
}

export interface ITeamState {
    teams?: ITeam[];
    loading: boolean;
    error?: string;
}
